export default __webpack_public_path__ + "static/media/illustrativeAlarmClock.116cd863.svg";